import React, { useState } from 'react';
import { apiService } from '../services/api';

const StripeTestComponent: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string>('');

  const isDevelopment = process.env.REACT_APP_USE_STRIPE_INTEGRATION !== 'true';

  const testStripeIntegration = async () => {
    setLoading(true);
    setError('');
    setResult(null);

    try {
      // Mock event data for testing
      const mockEvent = {
        id: '0d003762-a58b-41b1-be81-8a3fa67268ac', // Test event ID from docs
        title: 'Test Event',
        description: 'Test event description',
        startDateTime: new Date().toISOString(),
        location: 'Test Location',
        ticketCategories: [
          {
            id: 'cat-1',
            name: 'General Admission',
            price: 25,
            currency: 'EUR',
            isFree: false
          }
        ]
      };

      const mockSelectedTickets = {
        'cat-1': 1
      };

      const mockTicketUserInfo = {
        'cat-1_0': {
          name: 'Test User',
          email: 'test@example.com',
          phone: '+351912345678'
        }
      };

      // Test the integration
      const checkoutUrl = await apiService.initiateStripeCheckout(
        mockEvent as any,
        mockSelectedTickets,
        mockTicketUserInfo,
        'test@example.com'
      );

      setResult({ 
        checkoutUrl,
        mode: isDevelopment ? 'Development (Simulated)' : 'Production (Real Stripe)'
      });
    } catch (err: any) {
      setError(err.message || 'Test failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', border: '1px solid #ccc', margin: '20px' }}>
      <h3>Stripe Integration Test</h3>
      
      <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: isDevelopment ? '#fff3cd' : '#d4edda', borderRadius: '4px' }}>
        <strong>Current Mode:</strong> {isDevelopment ? 'Development (Simulated)' : 'Production (Real Stripe API)'}
        <br />
        <small>
          {isDevelopment 
            ? 'No real API calls will be made. CORS issues are bypassed.' 
            : 'Real Stripe API calls will be made to production endpoints.'
          }
        </small>
      </div>
      
      <button 
        onClick={testStripeIntegration}
        disabled={loading}
        style={{ 
          padding: '10px 20px',
          backgroundColor: loading ? '#ccc' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Testing...' : 'Test Stripe Integration'}
      </button>

      {error && (
        <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f8d7da', color: '#721c24', borderRadius: '4px' }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      {result && (
        <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#d4edda', color: '#155724', borderRadius: '4px' }}>
          <strong>Success!</strong>
          <br />
          <strong>Mode:</strong> {result.mode}
          <br />
          <strong>Checkout URL:</strong> {result.checkoutUrl}
          <br />
          <button 
            onClick={() => window.open(result.checkoutUrl, '_blank')}
            style={{ 
              marginTop: '10px',
              padding: '5px 10px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Open Checkout
          </button>
        </div>
      )}
    </div>
  );
};

export default StripeTestComponent;